module.exports = __webpack_public_path__ + "img/zoom_score.862b569c.webp";